export const formFieldsConstants = {
  testArea: {
    max: 10000,
  },
  remarks: {
    max: 500,
  },
} as const;
